import { render, staticRenderFns } from "./qfjl.vue?vue&type=template&id=208de4ec&"
import script from "./qfjl.vue?vue&type=script&lang=js&"
export * from "./qfjl.vue?vue&type=script&lang=js&"
import style0 from "./qfjl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports